var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextUnderlineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 51,
    viewBox: "0 0 40 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.888916 45.3678H39.7778V50.9233H0.888916V45.3678ZM3.66669 0.92334V23.1456C3.66669 32.34 11.1389 39.8122 20.3334 39.8122C29.5278 39.8122 37 32.34 37 23.1456V0.92334H30.0556V23.1456C30.0556 28.5067 25.6945 32.8678 20.3334 32.8678C14.9722 32.8678 10.6111 28.5067 10.6111 23.1456V0.92334H3.66669Z",
    fill: "#1D1D1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextUnderlineIcon);
export default __webpack_public_path__ + "static/media/textUnderlineIcon.3175a7ce32854c6e3a31e8319c84c76f.svg";
export { ForwardRef as ReactComponent };